export default __webpack_public_path__ + "static/media/Crypto-Blue-logo.eda93d09.png";